import angular from "angular";
import panel from "../services";

function profileEdit (panel) {

    return {
        restrict: 'E',
        scope: {
            pc: '='
        },
        link: function(scope) {

        },
        template: require('./templates/profile/edit-profile.html')
    }
};

export default angular.module('directives.profileEdit', [panel]).directive('profileEdit', profileEdit).name;


// WEBPACK FOOTER //
// ./src/app/directives/profileEdit.js